import { format } from 'date-fns';

const toDate = (value) => {
  if (!value) return null;
  const s = String(value).trim();
  if (!s) return null;

  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}(:\d{2})?$/.test(s)) {
    const isoUtc = `${s.replace(' ', 'T')}${s.length === 16 ? ':00' : ''}Z`;
    const d = new Date(isoUtc);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/.test(s)) {
    const isoUtc = `${s}${s.length === 16 ? ':00' : ''}Z`;
    const d = new Date(isoUtc);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const formatDate = (dateString) => {
  if (!dateString) return '-';
  try {
    const d = toDate(dateString);
    if (!d) return String(dateString);
    return format(d, 'dd MMM yyyy');
  } catch (error) {
    return dateString;
  }
};

export const formatDateTime = (dateString) => {
  if (!dateString) return '-';
  try {
    const d = toDate(dateString);
    if (!d) return String(dateString);
    return format(d, 'dd MMM yyyy HH:mm');
  } catch (error) {
    return dateString;
  }
};

export const getStatusColor = (status) => {
  if (typeof status !== 'string') return 'bg-gray-100 text-gray-800';
  
  switch (status.toLowerCase()) {
    case 'pending':
    case 'draft':
      return 'bg-gray-100 text-gray-800';
    case 'in progress':
    case 'dispatched':
    case 'forwarded':
      return 'bg-blue-100 text-blue-800';
    case 'completed':
    case 'delivered':
    case 'replied':
      return 'bg-green-100 text-green-800';
    case 'urgent':
      return 'bg-orange-100 text-orange-800';
    case 'most urgent':
      return 'bg-red-100 text-red-800';
    case 'returned':
    case 'closed':
      return 'bg-red-50 text-red-600';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

export const getPriorityColor = (priority) => {
  if (typeof priority !== 'string') return 'text-gray-600';

  switch (priority.toLowerCase()) {
    case 'urgent':
      return 'text-orange-600 font-medium';
    case 'most urgent':
      return 'text-red-600 font-bold';
    default:
      return 'text-gray-600';
  }
};
